import { type Ref, inject, type useShadowRoot } from 'vue';

export const initModalTeleportTarget = (modalTarget: Ref<HTMLElement | null>) => {
  const rootNode = inject<ReturnType<typeof useShadowRoot>>('shadowRoot', null);

  if (rootNode) {
    let host = rootNode.querySelector('#modal-teleport');

    if (!host) {
      host = document.createElement('div');
      host.id = 'modal-teleport';
      rootNode.appendChild(host);
    }

    if (host instanceof HTMLElement) {
      modalTarget.value = host;
    }
  }
};
